The type of event, i.e. PositionNotPosted. This corresponds to the `Event.typeCode` field in the GraphQL schema.
